<template>
    <svg @click="addToFavorite();" v-if="!isActive" class="not_active" width="16" height="20" viewBox="0 0 16 20" fill="none"
         xmlns="http://www.w3.org/2000/svg">
        <path d="M0.487805 0C0.22321 0.00365854 0.00599512 0.268073 0 0.487805V19.0244C5.60975e-05 19.2727 0.0542756 19.5521 0.266768 19.7561C0.479261 19.9601 0.747183 19.9999 0.97561 20C1.06358 20 1.15153 19.9764 1.22713 19.9314L7.56097 16.1814L13.8948 19.9314C13.9704 19.9764 14.0584 20.0004 14.1463 20C14.3748 19.9999 14.6427 19.9601 14.8552 19.7561C15.0677 19.5521 15.1219 19.2727 15.1219 19.0244V0.487805C15.1219 0.23239 14.8896 2.43902e-05 14.6341 0H0.487805ZM0.97561 0.97561H14.1463V18.9405L7.8125 15.1905C7.66154 15.0997 7.4604 15.0997 7.30945 15.1905L0.97561 18.9405V0.97561ZM7.56097 3.65854C7.29156 3.65854 7.07317 3.87693 7.07317 4.14634V7.07317H4.14634C3.87693 7.07317 3.65854 7.29156 3.65854 7.56097C3.65854 7.83039 3.87693 8.04878 4.14634 8.04878H7.07317V10.9756C7.07317 11.245 7.29156 11.4634 7.56097 11.4634C7.83039 11.4634 8.04878 11.245 8.04878 10.9756V8.04878H10.9756C11.245 8.04878 11.4634 7.83039 11.4634 7.56097C11.4634 7.29156 11.245 7.07317 10.9756 7.07317H8.04878V4.14634C8.04878 3.87693 7.83039 3.65854 7.56097 3.65854Z"
              fill="#8A8D92"/>
    </svg>
    <svg @click="addToFavorite" v-else width="16" height="20" class="active" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.487805 0C0.22321 0.00365854 0.00599512 0.268073 0 0.487805V19.0244C5.60975e-05 19.2727 0.0542756 19.5521 0.266768 19.7561C0.479261 19.9601 0.747183 19.9999 0.97561 20C1.06358 20 1.15153 19.9764 1.22713 19.9314L7.56097 16.1814L13.8948 19.9314C13.9704 19.9764 14.0584 20.0004 14.1463 20C14.3748 19.9999 14.6427 19.9601 14.8552 19.7561C15.0677 19.5521 15.1219 19.2727 15.1219 19.0244V0.487805C15.1219 0.23239 14.8896 2.43902e-05 14.6341 0H0.487805ZM0.97561 0.97561H14.1463V18.9405L7.8125 15.1905C7.66154 15.0997 7.4604 15.0997 7.30945 15.1905L0.97561 18.9405V0.97561ZM7.56097 3.65854C7.29156 3.65854 7.07317 3.87693 7.07317 4.14634V7.07317H4.14634C3.87693 7.07317 3.65854 7.29156 3.65854 7.56097C3.65854 7.83039 3.87693 8.04878 4.14634 8.04878H7.07317V10.9756C7.07317 11.245 7.29156 11.4634 7.56097 11.4634C7.83039 11.4634 8.04878 11.245 8.04878 10.9756V8.04878H10.9756C11.245 8.04878 11.4634 7.83039 11.4634 7.56097C11.4634 7.29156 11.245 7.07317 10.9756 7.07317H8.04878V4.14634C8.04878 3.87693 7.83039 3.65854 7.56097 3.65854Z" fill="#F90" />
    </svg>
</template>
<script setup>
import {defineEmits, defineProps, toRefs} from "vue";

const props = defineProps({
  isActive: {
    type: Boolean,
		default: false
  }
});
const { isActive } = toRefs(props);


const emit = defineEmits(['addToFavorite'])

function addToFavorite() {
  emit('addToFavorite')
}

</script>

<style scoped>
svg:hover path {
	fill: #F90;
}
</style>